import { prepTagsForSave } from 'servicestack/tags/_config'
import templateUrl from 'servicestack/tags/tags-prompt.htm'
import angular from 'angular'
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import modals from 'webmodals/modals'

class controller {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.request = {
            principalId: options.principalId || options.id || (options.request || {}).id,
            shard: options.shard || (options.shard || {}).shard,
            tags: angular.merge({}, options.tags, (options.request || {}).tags)
        };
        $ctrl.bus = new ServiceBus();
        if (Array.isArray(options.tagKinds))
            $ctrl.tagKinds = options.tagKinds;
        $ctrl.title = options.title || ' Tags...'
    }

    submit() {
        const $ctrl = this;
        const tags = prepTagsForSave($ctrl.request.tags);
        const req = {
            shard: $ctrl.request.shard,
            principalId: $ctrl.request.principalId,
            tags
        };

        $ctrl.bus.send('SaveTags.json', req).then(function (response) {
            $ctrl.$close($ctrl.request);
        });
    }
}

export default {
    open(options) {
        return modals.open(angular.extend({
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};
